<template>
    <div>
        <el-button type="primary" @click="showDialog = true">{{title}}</el-button>
        <el-dialog :title="'选择可派送区域'" :visible.sync="showDialog" width="40%" @close="closeDialog">
            <div>
                <div style="width: 100%;text-align: right;"><el-checkbox v-model="select" @change="selectAll('')">全选</el-checkbox><span style="margin-left: 8px;cursor: pointer;" @click="selectAll('clear')">清空</span></div>
                <el-form :model="areaTreeDate" ref="videoVideoForm" :rules="rules" label-width="120px" :inline="true"
                    size="small">
                    <el-form-item v-for="value, key in areaTreeDate" :key="key" style="width: 200px;">
                        <el-popover placement="top-start" width="600" trigger="hover">
                            <div>
                                <el-form :model="areaTreeDate" ref="videoVideoForm" :rules="rules" label-width="40px"
                                    :inline="true" size="small">
                                    <el-form-item v-for="item, key1 in value.children" :key="item" style="width: 140px;">
                                        <el-checkbox v-model="item.checked" @change="checkedChildren(item.checked,key)">{{ item.areaName }}</el-checkbox>
                                    </el-form-item>
                                </el-form>
                                <div style="font-size: 16px;color: red;">({{value.acount}}/{{value.count}})</div>
                            </div>
                            <el-checkbox v-model="value.checked" @change="checked(value.checked, key)" slot="reference">{{ value.areaName }}</el-checkbox>
                        </el-popover>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitForm">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get } from '@/utils/request.js';

export default {
    data() {
        return {
            showDialog: false,
            areaTreeDate: [], //地理位置
            select:false
        }
    },
    props:{
        title:{
            type:String,
            default:()=>{
                return '添加区域'
            }
        }
    },
    created() {
        this.getTreeData();
    },
    methods: {
        // 获取地理位置
        getTreeData() {
            get('/mpp/area/treeData').then((res) => {
                if (res.success) {
                    let array = res.treeData[0].children
                    array.forEach(element => {
                        let obj = {
                            id: element.id,
                            areaName: element.areaName,
                            checked: false,
                            children: [],
                            acount: 0,
                            count: 0,
                        }
                        for (const iterator of element.children) {
                            obj.count++
                            obj.children.push({
                                id: iterator.id,
                                areaName: iterator.areaName,
                                checked: false
                            })
                        }
                        this.areaTreeDate.push(obj)
                        console.log(this.areaTreeDate)
                    });
                }
            })
        },
        // 单一省市勾选
        checked(event,key,sign=""){
            if(sign != "select"){
                this.areaTreeDate[key].acount = event ? this.areaTreeDate[key].count : 0
                for(let iterator of this.areaTreeDate[key].children) {
                    iterator.checked = event
                }
            }
            let bool = true
            for (const iterator of this.areaTreeDate) {
                if(iterator.checked == false){
                    bool = false
                    break
                }
            }
            this.select = bool
        },
        checkedChildren(event,key){
            if(event){
                this.areaTreeDate[key].acount++
            }else{
                this.areaTreeDate[key].acount--
            }
            if(this.areaTreeDate[key].acount>0){
                this.areaTreeDate[key].checked = true
                this.checked(true,key,"select")
            }else{
                this.areaTreeDate[key].checked = false
                this.checked(false,key)
            }
        },
        // 全选全不选/清空
        selectAll(sign){
            if(sign == "clear"){
                this.select = false
            }
            this.areaTreeDate.forEach((element) => {
                element.checked = this.select
                element.acount = this.select ? element.count : 0
                for (let iterator of element.children) {
                    iterator.checked = this.select
                }
            })
        },
        // 确定
        submitForm(){
            if (!this.areaTreeDate.some(element => element.checked)) {
                return
            }
            let data = []
            this.areaTreeDate.forEach(element => {
                if (element.checked) {
                    data.push({
                        name: element.areaName,
                        cityId: element.id,
                        children: element.children.filter(child => child.checked).map(child => ({
                            name: child.areaName,
                            cityId: child.id
                        }))
                    })
                }
            })
            let str = data.map(item => item.name).join(";")
            this.showDialog = false
            this.$emit("address", data, str)
            this.selectAll('clear')
            // let bool = false
            // for (const iterator of this.areaTreeDate) {
            //     if(iterator.checked){
            //         bool = true
            //         break
            //     }
            // }
            // if(!bool){
            //     return
            // }
            // let arr = []
            // let arr1 = []
            // this.areaTreeDate.forEach(element => {
            //     let obj = {}
            //     if(element.checked){
            //         obj.name = element.areaName
            //         obj.cityId = element.id
            //         arr1.push(element.areaName)
            //         bool = true
            //     }
            //     obj.children = []
            //     for (const iterator of element.children) {
            //         if(iterator.checked){
            //             obj.children.push({
            //                 name:iterator.areaName,
            //                 cityId:iterator.id
            //             })
            //         }
            //     }
            //     if(obj.children.length == 0){
            //         delete obj.children
            //     }
            //     if(obj.name != undefined){
            //         arr.push(obj)
            //     }
            // });
            // let str = arr1.join(";")
            // this.showDialog = false
            // this.$emit("address",arr,str)
            // this.selectAll('clear')
        },
        closeDialog(){
            this.showDialog = false
            this.selectAll('clear')
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>